import React, {Component} from 'react';
import {browserHistory, Link} from 'react-router';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import PropTypes from 'prop-types';

import Validators from 'lib/validators';
import GA from 'lib/ga';
import I18n from 'lib/i18n/i18n';
import defaultCallback from 'lib/defaultCallback';
import {isJewelers, rootUrl, imageUrl} from 'helpers/ApplicationHelper';
import {InputEmail} from 'components/formElements';
import SellItemWizard from 'components/sellItemWizard';
import {sendCode, performLogIn} from 'actions/logIn';
import PopupHelp from "./popups/popupHelp";
import {H3, Regular, LargePrimaryButton} from '@worthy-npm/clarity';
import UserActions from 'lib/userActions';
import WorthyApiErrors from 'lib/api/worthyApiErrors'

class OneTimePassword extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pendingJewelryBox: this.props.pendingJewelryBox || undefined,
            requestId: null,
            phone: null,
            email: '',
            values: {},
            canResend: false
        };

        this._onSubmit = this._onSubmit.bind(this);
        this.renderWizard = this.renderWizard.bind(this);
        this.onChangeKey = this.onChangeKey.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.sendCode = this.sendCode.bind(this);
        this.switchToLoginClicked = this.switchToLoginClicked.bind(this);
        this.invalidNumberLoginClicked = this.invalidNumberLoginClicked.bind(this);
        this.openHelp = this.openHelp.bind(this)
    }

    componentDidMount(){
        this._email = this.refs['email'];
        const {pendingItem} = this.props;
        if (this.props.onSubmitForm) {
            this.state.onSubmitForm = this.props.onSubmitForm;
        if (pendingItem)
            this.setState({ pendingItem });
        } else {
            this.state.onLoginSuccessful = () => {
                this.redirectToUrl()
            }
        }
    }

    redirectToUrl(){
        const {location} = this.props;
        let redirectTo = location && location.state && location.state.redirectTo;
        let component = this.props.logIn;
        let nextPage = null;
        if(redirectTo) {
            nextPage = rootUrl(redirectTo);
        }
        else if (isJewelers(this.props.session)){
            nextPage = rootUrl('/jewelers');
        }
        else if (this.props.pendingItem) {
            GA.itemSubmissionSuccessfully();
            nextPage = `/item/${this.props.item.id}`;
        }
        else if (this.props.jewelryBox) {
            nextPage = `/multiple_jewelry/${this.props.jewelryBox.bundle_id}`;
        }
        window.location = nextPage || document.referrer || rootUrl('/items');
    }

    validateEmail() {
        let errorText;
        let valid = Validators.validateEmail(this.state.email);
        if (!valid) errorText = !this.state.email ? 'registerPage::form::errors::emptyEmail' : 'registerPage::form::errors::email';
        if (errorText){
            this._email.setError(I18n.getString(errorText));
        }
        return valid;
    }

    validateCode(){
        let errorText = '';
        let valid = (Object.values(this.state.values).join('').length === 4);
        if (!valid) errorText = 'Invalid password';
        this.setState({ errorText });
        return valid;
    }

    sendCode(stopAnimation){
        let valid = this.validateEmail();
        if (!valid){
            stopAnimation();
            return
        }
        this.setState(
          {
              values: {},
              canResend : false,
              errorText: null
          });

        this.props.sendCode({
            email: this.state.email,
            request_id: this.state.requestId
        }).then((response)=>{
            this.sendCodeResponse(response, stopAnimation)
        });
    }

    sendCodeResponse(response, stopAnimation){
        if (stopAnimation.name) stopAnimation();
        let data = response.payload.data,
          msg = data.error_text;

        if(response.payload instanceof WorthyApiErrors && response.payload._errObj[404]){
            return this._email.setError('To proceed, please enter a valid email address');
        }
        if (data.status === '3' && data.error_text.match('number'))
            msg = this.invalidNumberMsg();
        this.setState(
          {
              statusCode: data.status,
              errorText: msg,
              requestId: data.request_id,
              phone: data.phone
          }
        );
        setTimeout( (() => { this.setState({canResend : true}) }),30000)

    }

    invalidNumberMsg(){
        const {location, redirectTo} = this.props;
        return (
          <div className="text">
              {I18n.getString('oneTimePassword::invalidNumber')}
              <Link className="orange no-underline link strong" to={{pathname: '/signin',
                  state: {redirectTo: (redirectTo || location && location.state && location.state.redirectTo)}}}
                    onClick={this.invalidNumberLoginClicked}
              > Log in</Link>
          </div>
        )
    }

    verifyCode(stopAnimation){
        let valid = this.validateCode();
        const {item, jewelryBox} = this.props;
        if (!valid){
            stopAnimation();
            return
        }

        this.props.performLogIn({
            email: this.state.email,
            request_id: this.state.requestId,
            otp_code: Object.values(this.state.values).join(''),
            bundle_id: item && item.bundle ? item.bundle.id : jewelryBox ? jewelryBox.bundle_id : null
        }).then((response)=>{
            stopAnimation();
            if(!response.error){
                this.loginSuccessful();
            }else{
                this.setState({ errorText: 'Invalid code'});
            }
        });
    }

    loginSuccessful() {
        GA.loginFormSuccessfully();
        this.state.onLoginSuccessful();
    }

    _onSubmit(stopAnimation) {
        this.state.onSubmitForm ? this.state.onSubmitForm() : null;
        if (this.state.requestId)
            this.verifyCode(stopAnimation);
        else
            this.sendCode(stopAnimation);
    }

    renderWizard(){
        if(this.props.pendingItem){
            return (<SellItemWizard step={2} registerText={I18n.getString('common::sellItemWizard::stepSignIn')} />);
        }
    }

    handleChange(e){
        this._email.clearErrors();
        this.setState({email: e.target.value});
    }

    emailInput(){
        return (
          <InputEmail ref="email" inputId="login-email-input-a"
                      inputProps={{
                          required: true,
                          autoFocus: true,
                          placeholder: (I18n.getString('logInPage::form::email::placeholder')),
                          autoComplete: "disabled",
                          onChange: this.handleChange}}
          />
        )
    }
    simulateClick(e) {
        e.target.click();
    }

    codeInput(){
        const inputs = [];
        let { values, errorText } = this.state;
        for (let i = 0; i < 4; i++) {
            inputs.push(
              <input type='tel'
                     maxLength={1}
                     autoFocus={i === 0}
                     ref={(ref) => this.refs[i] = ref}
                     key={i}
                     name={`${i}`}
                     value={values[i] || ''}
                     className={`code-4-digits ${errorText ? 'border-error shake-error' : ''}`}
                     onChange={this.onChangeKey}
                     onFocus={i === 0 ? this.simulateClick : null}
              />
            )
        }
        return(
          <div className='align-center'>
              {inputs}
          </div>
        )
    }

    onChangeKey = e =>{
        let newValue = e.target.value;
        let values = this.state.values;
        if (newValue.length > 1) {
            for (let i = 0; i < newValue.length; i++) {
                values[i] = newValue.charAt(i)
            }
        }
        else
            values[e.target.name] =  newValue;
        this.setState({ values, errorText: '' });
        if (newValue.length > 1)
            e.target.blur();
        else
            if (e.target.name < 3) this.refs[Number(e.target.name) + 1].focus();
    };

    resendBtn(){
        return (
          <div className='align-center resend-space'>
          <Regular text={
              this.state.canResend ?
                <span className='medium-gray'> {I18n.getString('oneTimePassword::resend')} <a className='orange no-underline link strong' onClick={(stopAnimation) => this.sendCode(stopAnimation)}>{I18n.getString('oneTimePassword::resend2')}</a></span>
                :
                <span className='medium-gray'>{I18n.getString('oneTimePassword::tryAgain')}</span>
          } />
          </div>
        )
    }

    intro(){
        let msg = '';
        this.state.requestId ?
          msg = `${I18n.getString('oneTimePassword::4digits')}<br> <span class="four-digits-title">***-***-${this.state.phone}</span>` :
          msg = I18n.getString('oneTimePassword::enterYourEmail');
        return (
            <span dangerouslySetInnerHTML={{__html: msg }}/>
        )
    }

    errorMsg(){
        return(
          <div className={`error otp-error ${this.state.errorText ? 'margin-error' : ''} ${this.state.requestId ? 'invalid-code-error' : ''}`} >
              {this.state.errorText ? this.state.errorText : '' }
          </div>
        )

    }

    returnToSubmission = () => {
        const {location, redirectTo} = this.props;
        if (this.props.pendingItem) {
            browserHistory.push({pathname: '/register', state: {redirectTo: redirectTo || (location && location.state && location.state.redirectTo)}})
        } else {
            browserHistory.push('/submit/multiple_jewelry')
        }
    }

    bottom(){
        return (
          <div className="bottom less-margin align-center">
              {
                  this.state.requestId ?
                    this.help() :
                    I18n.getJsx('logInPage::switchToRegister',
                      {
                          register: <Link className="blue no-underline link strong" onClick={this.returnToSubmission}>
                              {I18n.getString('logInPage::registerNow')}
                          </Link>
                      })
              }
              <div className="logos">
                  <img alt='bbb' src={imageUrl('common/bbb.png')} />
                  <img alt='Secured Registration' src={imageUrl('common/secured_registration.png')} />
              </div>
              <div className="new-here">
                  {I18n.getJsx('registerPage::bottomText',
                      {
                          tndText:
                              <a href={rootUrl('/about/terms-and-conditions')} target="_blank" rel="noreferrer">
                                  {I18n.getString('registerPage::tndText')}
                              </a>,
                          privacyPolicyText:
                              <a href={rootUrl('/about/privacy-policy')} target="_blank" rel="noreferrer">
                                  {I18n.getString('registerPage::privacyPolicyText')}
                              </a>,
                      })}
              </div>
          </div>
        )
    }

    help(){
        return(
          <div>
              <div className='help-margin'>
                  <Link className="orange no-underline link strong" to={{pathname: '/signin',
                      state: {redirectTo: (this.props.redirectTo || this.props.location && this.props.location.state && this.props.location.state.redirectTo)}}}
                        onClick={this.switchToLoginClicked}
                  >{I18n.getString('oneTimePassword::switchToLogin')}</Link>
              </div>
              <div>{I18n.getString('oneTimePassword::noSuccess')}<a className="orange no-underline link strong" onClick={this.openHelp}> {I18n.getString('oneTimePassword::ourPhone')}</a></div>
          </div>
        )

    }
    switchToLoginClicked(){
        UserActions.logByEmail('One time password - "Login using email and password" link clicked', this.state.email);
    }
    invalidNumberLoginClicked(){
        UserActions.logByEmail('One time password - invalid phone - Login clicked', this.state.email);
    }
    openHelp() {
        UserActions.logByEmail('One time password - Phone number link clicked', this.state.email);
        PopupHelp.initPopup({single: true, modal: true});
    }

    render(){
        return (
          <div>
              {this.renderWizard()}
              <div className="login-container otp">
                  <div className='align-center'>
                      <H3 text={I18n.getString('oneTimePassword::title')}/>
                      <Regular text={this.intro()} />
                  </div>
                  <div className="login-container-form">
                      <div className='resend-space'>
                          { this.state.requestId ? this.codeInput() : this.emailInput() }
                          { this.errorMsg() }
                          { this.state.requestId ? this.resendBtn() : '' }
                          <div className={`continue-clarity-width submit-clarity-button-wrapper ${this.state.errorText || this.state.requestId ? '' : 'margin-error'}`}>
                              <LargePrimaryButton
                                text={this.props.pendingItem ? I18n.getString('logInPage::form::submitButtonPendingItem') : I18n.getString('logInPage::form::submitButton') }
                                click={(stopAnimation) => {
                                    this._onSubmit(stopAnimation)
                                }}
                                overrideWrapperCSS={{width: '100%'}}
                                overrideCSS={{backgroundColor: '#2D5DEC', borderRadius: '3px',
                                    width: '100%', padding: '11px 22px 12px',
                                    font: '500 16px Roboto', textTransform: 'none'}}
                              />
                          </div>
                      </div>
                      <br/>
                  </div>
                  { this.bottom() }
              </div>
          </div>
        );
    }
}

OneTimePassword.propTypes = Object.assign({
    onLoginSuccessful: PropTypes.func,
    onSubmitForm: PropTypes.func,
}, OneTimePassword.propTypes);

OneTimePassword.defaultProps = {
    onLoginSuccessful: defaultCallback,
};

const mapStateToProps = ({Session, LogIn, PendingItem, PendingJewelryBox, Item, JewelryBox}) => {
    return {
        session: Session,
        logIn: LogIn,
        pendingItem: PendingItem,
        pendingJewelryBox: PendingJewelryBox,
        item: Item,
        jewelryBox: JewelryBox
    }
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({sendCode, performLogIn}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(OneTimePassword);
